import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

export const Container = styled.div`
  text-align: left;

  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  padding: 10px 25px 10px 25px;
  cursor: pointer;
  font-weight: 500;
  .notification-container {
    width: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    margin-top: 3px;
  }
`;

export const StyledGrid = styled(Grid)`
  margin-top: 5px;
  background-color: #e6f1fa;
  border-radius: 5px;
  padding: 20px;
  font-weight: 300;
`;
export const StyledBinGrid = styled(Grid)`
  margin-top: 5px;
`;
export const StyledImg = {
  marginTop: '3px',
  width: '16px',
  height: '16px',
};
export const StyledSpan = {
  color: '#5493BD',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
};
export const StyledSpanCheck = {
  color: '#10BB00',
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 400,
};

export interface InboxeProps {
  title: string;
  managerInboxesId: any;
  setSelectedInboxeId: Function;
  selectedInboxeId: number;
  isSelectedInboxe: boolean;
}

const Inboxe = (props: InboxeProps) => {
  return (
    <Container
      data-testId="click-Inboxe"
      onClick={() => {
        props.setSelectedInboxeId(props.managerInboxesId);
      }}
    >
      <Grid container direction="row" alignItems="center">
        <StyledBinGrid
          item
          xs={10}
          style={{
            color: props.isSelectedInboxe ? '#0075C9' : '#000000',
          }}
        >
          {props.title}
        </StyledBinGrid>
        <StyledBinGrid item xs={2}>
          <IconButton
            aria-label="expand-row"
            size="small"
            data-testid={'expand-icon'}
          >
            <KeyboardArrowRightIcon
              color={props.isSelectedInboxe ? 'primary' : undefined}
            />
          </IconButton>
        </StyledBinGrid>
      </Grid>
    </Container>
  );
};

export default Inboxe;
